import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import "primereact/resources/themes/viva-dark/theme.css";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import UserImage from "components/commons/UserImage";

function EmploymentsSimpleTable({
    employmentsData
}) {

    const [t, i18n] = useTranslation(["global"])
    const dt = useRef(null);


    /**
     *
     *  TEMPLATE HOLDERS 
     * 
     * */


    const avatarTemplate = (employment) => {
        return <div className="text-end"><UserImage guid={employment.user.guid} className="text-end" /></div>
    }

    const displayNameTemplate = (employment) => {
        return <>

            <span>{employment.user.displayName}</span>
        </>
    }

    const roleTemplate = (employment) => {
        return <span className="badge " style={{ backgroundColor: employment.role.backgroundColor, color: employment.role.textColor, padding: "10px" }}> {employment.role.name} </span>
    }


    const actionsTemplate = (employment) => {
        return (
            <>
                <NavLink to={{ pathname: "/dashboard/employees/see-employment" }} state={{ userGUID: employment.user.guid }} className="btn btn-light me-1"><i className="fa-solid fa-eye"></i></NavLink>
            </>
        )
    }



    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    return (
        <>
            <DataTable
                value={employmentsData}
                stripedRows
                tableStyle={{ minWidth: '50rem' }}
                paginator rows={25}
                rowsPerPageOptions={[5, 10, 25, 50]}
                dataKey="guid"

                ref={dt}
            >
                <Column body={avatarTemplate}   ></Column>
                <Column body={displayNameTemplate} field="user.displayName" header={t("property.name")} sortable  ></Column>
                <Column body={roleTemplate} header={t("property.role")} field="role.name" sortable></Column>
                <Column field="roleLabel" header={t("property.companyRole_short")}  sortable></Column>
                <Column body={actionsTemplate} header={t("property.actions")}></Column>
            </DataTable>
            <div className="container text-end p-2">
                <h6>{t("action.export")}</h6>
                <button className="btn btn-primary" onClick={() => exportCSV(false)}><i className="fa-solid fa-download"></i> .CSV</button>
            </div>
        </>


    )

}

export default EmploymentsSimpleTable